import Axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { getAxiosConfig, getHZAxiosConfig } from './config'

const AxiosInstanceFunc: AxiosInstance = Axios.create(getAxiosConfig())

const HZAxiosInstanceFunc: AxiosInstance = Axios.create(getHZAxiosConfig())

AxiosInstanceFunc.defaults.headers.common['Authorization'] = localStorage.getItem('token')
  ? 'bearer ' + localStorage.getItem('token')
  : ''

AxiosInstanceFunc.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<AxiosError> => Promise.reject(error)
)

const setAxiosInstanceFuncAuthorizationHeader = (token: string) => {
  AxiosInstanceFunc.defaults.headers.common['Authorization'] = 'bearer ' + token
}

export default AxiosInstanceFunc

export { setAxiosInstanceFuncAuthorizationHeader }

export { HZAxiosInstanceFunc }
